import { ComparisonRow, PlanMetadata, PlanMetadataTypes } from "./types";

// // // //

// NOTE - kept for reference, can remove later
// export const ACADEMIC_PRICING_PLAN_METADATA: PlanMetadata = {
//     id: "ACADEMIC",
//     name: "Academic",
//     price: "$149.99",
//     period: "/month",
//     description:
//         "For academic institutions and researchers to access tokenized real-world asset data",
//     features: [
//         "Unlimited CSV downloads for all metrics",
//         {
//             text: "Full API access",
//             badge: "See Data Catalog ↗",
//             badgeLink: Routes.catalog,
//         },
//         "Public citations required",
//         "No technical support",
//         "No redistribution or commercial license rights",
//     ],
//     cta: "Upgrade to Pro",
//     popular: true,
// };

export const PLAN_METADATA_FREE: PlanMetadata = {
    name: "Preview",
    type: PlanMetadataTypes.PREVIEW,
    purpose: "For exploring tokenized markets through our platform.",
    price: "Free",
    period: null,
    features: [
        "Access first-party tokenized asset reference data and market metrics",
        "Connect AIs to data via MCP",
        "Create and save custom charts",
        "Sample CSV/XLSX downloads",
        "Developer evaluation API",
    ],
};

export const PLAN_METADATA_PRO: PlanMetadata = {
    name: "Pro",
    type: PlanMetadataTypes.PRO,
    purpose: "For professional analysts and research teams.",
    price: "$500",
    period: "/month",
    features: [
        "Full data access",
        "3 seats included",
        "+$100/month per additional seat",
        "Unlimited MCP access",
        "Unlimited saved charts & tables",
        "Full data downloads",
    ],
};

export const PLAN_METADATA_ENTERPRISE: PlanMetadata = {
    name: "Enterprise",
    type: PlanMetadataTypes.ENTERPRISE,
    purpose: "For organizations building with tokenized assets.",
    price: "Custom",
    period: null,
    features: [
        "Everything in Pro",
        "Production API access",
        "Datashare delivery options",
        "Organizational data licensing",
        "Enterprise support",
        "Redistribution rights available",
    ],
};

export const PLAN_METADATA: PlanMetadata[] = [
    PLAN_METADATA_FREE,
    PLAN_METADATA_PRO,
    PLAN_METADATA_ENTERPRISE,
];

export const PLAN_COMPARISON_ROWS: { title: string; rows: ComparisonRow[] }[] =
    [
        {
            title: "",
            rows: [
                {
                    feature: "Best for",
                    values: [
                        "—",
                        "Independent analysts performing occasional research",
                        "Professional analysts and teams performing recurring research",
                        "Organizations who need systematic data access for building products or ingesting into org-wide BI",
                    ],
                },
                {
                    feature: "Pricing",
                    values: ["Free", "Free", "$500/month", "Custom"],
                },
                {
                    feature: "Seats",
                    values: [
                        "N/A",
                        "N/A",
                        "3 included. $100/month/seat after.",
                        "Custom",
                    ],
                },
            ],
        },
        {
            title: "RWA.xyz App",
            rows: [
                { feature: "Homepage", values: [true, true, true, true] },
                { feature: "Asset Screener", values: [true, true, true, true] },
                {
                    feature: "New Asset Monitor",
                    values: ["Limited", true, true, true],
                },
                {
                    feature: "Asset Managers",
                    values: ["Limited", true, true, true],
                },
                {
                    feature: "Tokenization Platforms",
                    values: ["Limited", true, true, true],
                },
                {
                    feature: "Blockchain Networks",
                    values: ["Limited", true, true, true],
                },
                {
                    feature: "Assets",
                    values: [
                        "Limited",
                        "25 per month",
                        "Unlimited",
                        "Unlimited",
                    ],
                },
            ],
        },
        {
            title: "Data Downloads",
            rows: [
                {
                    feature: "Asset reference data",
                    values: [false, "Top 10 assets", "All", "All"],
                },
                {
                    feature: "Asset manager data",
                    values: [false, "Top 10 managers", "All", "All"],
                },
                {
                    feature: "Tokenization platform data",
                    values: [false, "Top 10 platforms", "All", "All"],
                },
                {
                    feature: "Blockchain network data",
                    values: [false, "Top 10 networks", "All", "All"],
                },
                {
                    feature: "Time series chart history",
                    values: [
                        false,
                        "Past 30 days",
                        "Full history",
                        "Full history",
                    ],
                },
            ],
        },
        {
            title: "Customization",
            rows: [
                {
                    feature: "Custom charts",
                    values: [
                        false,
                        false,
                        // "3 saved charts/tables", // TODO - remove this once we roll out Charts to free-tier users
                        "Unlimited",
                        "Unlimited",
                    ],
                },
                {
                    feature: "Custom tables",
                    values: [
                        false,
                        false,
                        // "3 saved charts/tables", // TODO - remove this once we roll out Charts to free-tier users
                        "Unlimited",
                        "Unlimited",
                    ],
                },
            ],
        },
        {
            title: "AI",
            rows: [
                {
                    feature: "MCP Server",
                    description: "Claude, ChatGPT, Cursor, and more",
                    values: [
                        false,
                        false,
                        // "50 tool calls per month", // TODO - remove this once we roll out MCP access to free-tier users
                        "Unlimited*",
                        "Unlimited",
                    ],
                },
                {
                    feature: "AI Chat",
                    description: "Coming soon",
                    values: [
                        false,
                        "10 messages per month",
                        "1,000 messages per month",
                        "Custom",
                    ],
                },
            ],
        },
        {
            title: "API",
            rows: [
                {
                    feature: "API access",
                    values: [false, "Limited", "Limited", true],
                },
                {
                    feature: "Requests",
                    values: [
                        "N/A",
                        "N/A",
                        // "10 requests per month", // TODO - remove this once we roll out API access to free-tier users
                        "10 requests per month",
                        "Unlimited*",
                    ],
                },
                {
                    feature: "Reference data responses",
                    values: [
                        false,
                        false,
                        // "10 entities per request", // TODO - remove this once we roll out API access to free-tier users
                        "10 entities per request",
                        "Unlimited*",
                    ],
                },
                {
                    feature: "Time series responses",
                    values: [
                        false,
                        false,
                        // "30 days per request", // TODO - remove this once we roll out API access to free-tier users
                        "30 days per request",
                        "Unlimited*",
                    ],
                },
            ],
        },
        {
            title: "Data Share",
            rows: [
                {
                    feature: "Snowflake Share",
                    values: [false, false, false, true],
                },
                {
                    feature: "Databricks Delta Share",
                    values: [false, false, false, true],
                },
                {
                    feature: "Flat file delivery",
                    values: [false, false, false, true],
                },
            ],
        },
        {
            title: "Support & SLA",
            rows: [
                { feature: "Email", values: [false, false, true, true] },
                { feature: "Slack", values: [false, false, false, true] },
            ],
        },
        {
            title: "Data License",
            rows: [
                {
                    feature: "Commercial Use",
                    values: [false, false, true, true],
                },
                {
                    feature: "Redistribution",
                    values: [false, false, false, "Custom"],
                },
            ],
        },
    ];
